import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Http from '../shared/http';
import AddGroup from './AddGroup';
import toastr from 'toastr';

export default class EditGroup extends Component {

  static defaultProps = {
    name: '',
    clients: [],
    selectedClients: '',
  }

  static propTypes = {
    name: PropTypes.string,
    clients: PropTypes.array,
    selectedClients: PropTypes.string,
    tenant: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      clients: this.props.clients,
      selectedClients: this.props.selectedClients,
      groupId: null
    };
  }

  componentDidMount() {
    window.addEventListener("editGroup", (e) => {
      const groupId = e.detail.groupId;

      Http.request(`/wealth_managers/groups/${groupId}/details`, "GET").then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            this.setState({
              name: data.name,
              selectedClients: data.clients,
              groupId: groupId
            });
          });
        } else {
          toastr.warning("There was a problem editing this group.");
        }
      });
    });
  }
  render() {
    return (
      <AddGroup name={this.state.name}
        clients={this.state.clients}
        isEdit={true}
        groupId={this.state.groupId}
        selectedClients={this.state.selectedClients}
        tenant={this.props.tenant} />
    );
  }
}
